<hr>
<al-tabs [tabInfo]="tabInfoAuditLogs" [selectedTab$]="selectedAuditLogsTab$"></al-tabs>

<ng-container [ngSwitch]="selectedAuditLogsTab$ | async">
	<ng-container *ngSwitchCase="1">
		<app-shell-admin-audit-logs-companies-users></app-shell-admin-audit-logs-companies-users>
	</ng-container>
	<ng-container *ngSwitchCase="2">
		<app-shell-admin-audit-user-management></app-shell-admin-audit-user-management>
	</ng-container>
	<ng-container *ngSwitchCase="3">
		<app-shell-admin-audit-logs-links></app-shell-admin-audit-logs-links>
	</ng-container>
	<ng-container *ngSwitchCase="4">
		<app-shell-admin-audit-logs-links-linksettings-updates></app-shell-admin-audit-logs-links-linksettings-updates>
	</ng-container>
	<ng-container *ngSwitchCase="5">
		<app-shell-admin-audit-logs-permissions></app-shell-admin-audit-logs-permissions>
	</ng-container>
	<ng-container *ngSwitchCase="6">
		<app-shell-admin-audit-logs-functionapp></app-shell-admin-audit-logs-functionapp>
	</ng-container>
</ng-container>
